var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.5@core-js/library/modules/_shared-key.js
// module id = 107
// module chunks = 0 1